import { render, staticRenderFns } from "./HistoryApprovals.vue?vue&type=template&id=6e84968e"
import script from "./HistoryApprovals.vue?vue&type=script&lang=js"
export * from "./HistoryApprovals.vue?vue&type=script&lang=js"
import style0 from "./HistoryApprovals.vue?vue&type=style&index=0&id=6e84968e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports